import { DeptUser } from '@eastcoal/api/auth/interface'

import { isUserNode } from '../../utils/isUserNode'

import { DeptUserCascaderOption } from './interface'

const hasLeafNode = (data?: DeptUserCascaderOption[]): boolean => {
  if (!data?.length) {
    return false
  }
  return data.some(({ isLeaf, children }) => {
    if (isLeaf) return true
    return hasLeafNode(children)
  })
}
export const transformDeptUserCascadeData = (
  data: DeptUser[]
): DeptUserCascaderOption[] => {
  return data.map(({ id, name, type, children }) => {
    const isUser = isUserNode(type)
    const newChildren = children && transformDeptUserCascadeData(children)
    const enable = isUser || hasLeafNode(newChildren)

    return {
      label: name,
      value: id,
      isLeaf: isUser,
      disabled: !enable,
      children: newChildren
    } as DeptUserCascaderOption
  })
}
